var classes = undefined;

export { classes as default };
//# sourceMappingURL=fader.scss.js.map
